// Phase 39 — two polished, static Quick Reply sample outputs for the
// workspace preview. Neutral, professional copy. Every card carries the
// "SAMPLE OUTPUT" label at the top so nothing looks live.

const QUICK_REPLY_SAMPLES = [
  {
    id: "quick-reply-platform-idea",
    kind: "PLATFORM_IDEA",
    prompt:
      "Should we build a compliance-monitoring API for regulated AI apps? What's the shortest path to a defensible wedge?",
    answer: {
      headline:
        "Yes — the wedge is model-provenance logging for high-risk AI decisions.",
      why_now:
        "The EU AI Act's high-risk-system logging obligation begins enforcement in 2026, and most AI infrastructure vendors ship inference logs without a durable audit chain.",
      shortest_path: [
        "SDK that wraps any inference call (OpenAI, Anthropic, self-hosted) and stores a signed, immutable record: prompt hash, model version, output hash, user role, timestamp.",
        "Read API for regulators and auditors that returns a single chain-of-custody view per user or per decision.",
        "Ship with a Postgres reference schema, an S3-compatible sink, and a policy-as-code layer for retention and redaction.",
      ],
      first_customers:
        "Fintech AML/KYC teams shipping LLM copilots, and healthtech vendors running clinical-decision support (research use only).",
      what_to_test_first:
        "Whether five design-partner CTOs will pre-commit to a 60-day integration if you deliver the SDK + audit read API — no marketing, no landing page.",
    },
  },
  {
    id: "quick-reply-technical-research",
    kind: "TECHNICAL_RESEARCH",
    prompt:
      "How close is single-cell CRISPR screening to routine use for target discovery in solid tumors?",
    answer: {
      headline:
        "Close enough to plan around, not close enough to deploy at scale in 2026.",
      state_of_the_field:
        "Perturb-seq and CROP-seq now routinely resolve hundreds of gene knockouts at single-cell resolution in 2D cultures. Solid-tumor organoid work is emerging but bottlenecked on delivery efficiency and cell-yield after dissociation.",
      three_load_bearing_facts: [
        "Guide-delivery efficiency in dissociated primary tumor cells still lags cell-line baselines by roughly one order of magnitude.",
        "Doublet and dropout rates in tumor single-cell libraries compress the effective screen power below what published tables imply.",
        "Cost per meaningful perturbation-cell dropped substantially from 2023 to 2025, but sample-prep labor remains the dominant real cost.",
      ],
      what_a_serious_team_would_do_next: [
        "Benchmark three delivery modalities (lentiviral, AAV, electroporation) on the same organoid line before committing to a screen.",
        "Design the screen with a paired dropout + growth phenotype so results survive downstream single-cell noise.",
        "Reserve at least 20% of the budget for validation in a matched xenograft model.",
      ],
      research_workflow_note:
        "This is a research-workflow scoping answer. It does not constitute clinical or medical guidance and does not replace expert review.",
    },
  },
];

export default QUICK_REPLY_SAMPLES;
